import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import PageHero from "../components/site/PageHero";
import { PageSection, InfoCards, CTABand, DisclaimerBox } from "../components/site/ContentBlocks";
import { HEALTHCARE_DISCLAIMER } from "../data/content";

const PARTNERSHIP_AREAS = [
    {
        title: "International Patient Referrals",
        copy: "We introduce suitable international patients to hospitals, clinics and specialists whose services match the patient's needs and destination preferences.",
    },
    {
        title: "Coordinated Communication",
        copy: "We support clear communication between providers and patients — case summaries, medical documents, treatment plans, quotations and appointment scheduling.",
    },
    {
        title: "Patient Journey Support",
        copy: "Around the clinical care you provide, our teams help coordinate travel, translation, accommodation and recovery arrangements for your international patients.",
    },
    {
        title: "Long-Term Relationships",
        copy: "We build ongoing referral relationships with providers who communicate clearly, quote transparently and support international patients professionally.",
    },
];

export default function HealthcarePartnerships() {
    return (
        <div className="grain bg-navy-deep" data-testid="healthcare-partnerships-page">
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: "Healthcare Partnerships | Hospitals & Clinics — Viet Medica Ltd",
                        description:
                            "Partnership coordination for hospitals, clinics and specialists welcoming international patients across Vietnam, India, Thailand and China.",
                        path: "/healthcare-partnerships",
                    }}
                    crumbs={[{ label: "Healthcare & Medical Tourism", href: "/healthcare-medical-tourism" }, { label: "Partnerships" }]}
                    eyebrow="Healthcare & Medical Tourism"
                    title="Healthcare"
                    titleEm="Partnerships."
                    copy="Viet Medica Ltd works with hospitals, clinics and specialist providers that welcome international patients. We connect suitable patients with suitable providers and support the communication around every referral."
                />

                <PageSection eyebrow="Working Together" title="How We Work with Providers" testid="partnership-areas">
                    <InfoCards cards={PARTNERSHIP_AREAS} cols={2} />
                    <div className="mt-10">
                        <DisclaimerBox text={HEALTHCARE_DISCLAIMER} testid="partnerships-disclaimer" />
                    </div>
                </PageSection>

                <section className="bg-navy-surface py-20 lg:py-28">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <CTABand
                            title="Discuss a healthcare partnership."
                            primary={{ label: "Partnership Enquiry", to: "/partnership-enquiry", testid: "partnerships-enquiry-cta" }}
                            secondary={{ label: "About Viet Medica", to: "/about", testid: "partnerships-about-cta" }}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
